'use strict';

var Util = require('openchemlib').Util;

module.exports = function getDiastereotopicHoseCodes(options) {
    var options=options || {};
    var diaIDs=this.getDiastereotopicAtomIDs(options).map(a => ({oclID: a}));
    diaIDs.forEach(function(diaID) {
        var hoses=Util.getHoseCodesFromDiastereotopicID(diaID.oclID, options);
        diaID.hoses=[];
        var level=1;
        for (var hose of hoses) {
            diaID.hoses.push(
                {
                    level: level++,
                    oclID: hose
                })
        }
    });
    return diaIDs;
};



//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/src/extend/getDiastereotopicHoseCodes.js
// module id = 54
// module chunks = 0